import React from 'react';
import { $EmptyNotice, $ImgContainer } from './styles';
import empty from '../assets/icons/emptyTable.svg';
import { Title } from '../';
export const Notice = ({ message = '' }) => (React.createElement($EmptyNotice, null,
    React.createElement($ImgContainer, null,
        React.createElement("img", { src: empty, alt: 'empty' })),
    React.createElement(Title, { alternate: true }, message)));
